module.exports = __webpack_public_path__ + "ingelahero.jpg?c2be61ba86d032e18a0afb7fe720888b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artists/ingelahero.jpg
// module id = 1063
// module chunks = 0